import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBalanceScale, FaCalendarCheck, FaHome } from "react-icons/fa";

import DropdownSalon from "./DropdownSalon";
import { IoIosArrowDown } from "react-icons/io";
import { FaGift, FaMoneyBillWave, FaUserPlus } from "react-icons/fa6";
import { FaMoneyCheckAlt } from "react-icons/fa";
import { useSelector } from "react-redux";
import {
  MdLiveHelp,
  MdSupportAgent,
  MdLocalOffer,
  MdOutlineDesignServices,
  MdOutlineQuiz,
  MdOutlineReportProblem,
  MdOutlineSupportAgent,
} from "react-icons/md";
import { AiOutlineCustomerService } from "react-icons/ai";

function Sidebar({ isOpen }) {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const { lang, translations, dir } = useSelector((state) => state.language);
  const isRtl = lang === "ar";
  const location = useLocation();
  const isDashboardActive = location.pathname === "/";
  const isUserActive = location.pathname.includes("/users");
  const isPaymentActive = location.pathname.includes("/payments");
  const isCouponActive = location.pathname.includes("/coupons");
  const isChargeActive = location.pathname.includes("/charges");
  const isContactUsActive = location.pathname.includes("/contactUs");
  const isOfferActive = location.pathname.includes("/offers");
  const isServiceActive = location.pathname.includes("/services");
  const isBookingActive = location.pathname.includes("/booking");
  const isTicketActive = location.pathname.includes("/customer/tickets");
  const isReportActive = location.pathname.includes("/customer/reports");
  const isQueryActive = location.pathname.includes("/customer/queries");
  const isComplaintActive = location.pathname.includes("/customer/complaints");
  const [isSupportOffersOpen, setIsSupportOffersOpen] = useState(false);
  const [isCustomerSupportOpen, setIsCustomerSupportOpen] = useState(false);

  useEffect(() => {
    // Open parent dropdown if on child route
    if (location.pathname.startsWith("/customer")) {
      setIsCustomerSupportOpen(true);
    }
    if (location.pathname === "/faqs" || location.pathname === "/offers") {
      setIsSupportOffersOpen(true);
    }
  }, [location.pathname]);

  // Check screen size on mount and resize
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);
  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  return (
    //     <div
    //   className={`fixed md:relative top-0 left-0 z-30 h-full bg-gray-900 text-white shadow-lg transition-all duration-300 flex flex-col
    //     ${
    //       isMobile
    //         ? isOpen
    //           ? `${isRtl ? 'right-0' : 'left-0'} translate-x-0 w-64 `
    //           : `${isRtl ? 'right-[-100%]' : 'left-[-100%]'} w-64`
    //         : isOpen
    //           ? `w-64 ${isRtl ? 'right-0' : 'left-0'}`
    //           : `w-16 ${isRtl ? 'right-0' : 'left-0'}`
    //     }
    //   `}
    // >
    <div
      className={`fixed md:relative top-0 z-30 h-full bg-gray-900 text-white shadow-lg flex flex-col
    ${
      isMobile
        ? `${isRtl ? "right-0 left-auto" : "left-0 right-auto"} transform ${
            isOpen
              ? "translate-x-0"
              : isRtl
              ? "translate-x-full"
              : "-translate-x-full"
          } w-64 transition-transform duration-300 ease-in-out`
        : `${isRtl ? "right-0 left-auto" : "left-0 right-auto"} ${
            isOpen ? "w-64" : "w-16"
          } transition-all duration-300 ease-in-out`
    }
  `}
      dir={isRtl ? "rtl" : "ltr"}
    >
      <div className="h-16 flex items-center p-2 bg-[#5A189A] text-white">
        {isOpen ? (
          <>
            <span>
              <img
                src="/images/logo/logo.png"
                alt="User Profile"
                className="rounded-full w-10 h-10 m-2 object-cover "
              />
            </span>
            <h2>{translations.sidebar.jeema}</h2>
          </>
        ) : (
          <img
            src="/images/logo/logo.png"
            alt="User Profile"
            className="rounded-full w-10 h-10 object-cover "
          />
        )}
      </div>

      <div className="flex-1 overflow-y-auto w-full scrollbar-hide pb-3">
        <div className="w-full mt-2">
          <Link
            to="/"
            className={`flex items-center gap-2 p-2 text-white no-underline w-full ${
              isDashboardActive ? "bg-[#5A189A]" : "hover:bg-gray-700"
            } ${
              isOpen
                ? `${isRtl ? "pr-4" : "pl-4"}`
                : "justify-center"
            }`}
          >
            <FaHome />
            {isOpen && <span>{translations.sidebar.dashboard}</span>}
          </Link>
        </div>

        <div className="mt-4 w-full">
          {isOpen && (
            <p className="mb-2 px-4 py-2 bg-gray-700 ">
              {translations.sidebar.appManagement}
            </p>
          )}

          <ul className="space-y-1 p-0 m-0 w-full list-none ">
            <li className="w-full ">
              <DropdownSalon
                isOpen={isOpen}
                openDropdown={openDropdown}
                toggleDropdown={toggleDropdown}
              />
            </li>

            <li className="w-full">
              <Link
                to="/users"
                className="group w-full block no-underline text-white "
              >
                <div
                  className={`flex items-center gap-2 py-2 w-full transition-colors duration-200 ${
                    isOpen
                      ? `${
                          isRtl
                            ? "pr-12"
                            : "pl-12"
                        }`
                      : "justify-center"
                  } ${isUserActive ? "bg-[#5A189A]" : "hover:bg-gray-700"}`}
                >
                  <FaUserPlus className={isOpen ? "" : "text-xl"} />
                  {isOpen && <span>{translations.sidebar.users}</span>}
                </div>
              </Link>
            </li>
            <li className="w-full">
              <Link
                to="/services"
                className="group w-full block no-underline text-white "
              >
                <div
                  className={`flex items-center gap-2 py-2 w-full transition-colors duration-200 ${
                    isOpen
                      ? `${
                          isRtl
                            ? "pr-12"
                            : "pl-12"
                        }`
                      : "justify-center"
                  } ${isServiceActive ? "bg-[#5A189A]" : "hover:bg-gray-700"}`}
                >
                  <MdOutlineDesignServices
                    className={isOpen ? "" : "text-xl"}
                  />
                  {isOpen && <span>{translations.sidebar.services}</span>}
                </div>
              </Link>
              {/* <DropdownService
                isOpen={isOpen}
                openDropdown={openDropdown}
                toggleDropdown={toggleDropdown}
                <FaCalendarCheck className={isOpen ? "" : "text-xl"} />
              /> */}
            </li>
            <li className="w-full">
              <Link
                to="/booking"
                className="group w-full block no-underline text-white "
              >
                <div
                  className={`flex items-center gap-2 py-2 w-full transition-colors duration-200 ${
                    isOpen
                      ? `${
                          isRtl
                            ? "pr-12"
                            : "pl-12"
                        }`
                      : "justify-center"
                  } ${isBookingActive ? "bg-[#5A189A]" : "hover:bg-gray-700"}`}
                >
                  <FaCalendarCheck className={isOpen ? "" : "text-xl"} />
                  {isOpen && <span>{translations.sidebar.bookings}</span>}
                </div>
              </Link>
              {/* <DropdownBooking
                isOpen={isOpen}
                openDropdown={openDropdown}
                toggleDropdown={toggleDropdown}
              /> */}
            </li>
            {/* <li className="w-full">
              <Link
                to="/"
                className="group w-full block no-underline text-black hover:bg-gray-100"
              >
                <div
                  className={`flex items-center gap-2 py-2   w-full group-hover:bg-grey-100 group-hover:text-green-900 transition-colors duration-200 ${
                    isOpen ? "justify-start px-4" : "justify-center"
                  }`}
                >
                  <RiCouponFill className={isOpen ? "" : "text-xl"} />
                  {isOpen && <span>Coupons</span>}
                </div>
              </Link>
            </li> */}
          </ul>
        </div>

        <div className="mt-4 w-full">
          {isOpen && (
            <p className="mb-2 px-4 py-2 bg-gray-700  ">
              {translations.sidebar.payments}
            </p>
          )}
          <ul className="space-y-2 p-0 m-0 w-full list-none">
            <li>
              <Link
                to="/payments"
                className="group w-full block no-underline text-white hover:bg-gray-700"
              >
                <div
                  className={`flex items-center gap-2 py-2  w-full group-hover:bg-grey-100  transition-colors duration-200 ${
                    isOpen
                      ? `${
                          isRtl
                            ? "pr-12"
                            : "pl-12"
                        }`
                      : "justify-center"
                  }
                   ${isPaymentActive ? "bg-[#5A189A]" : "hover:bg-gray-700"}
                  `}
                >
                  <FaMoneyCheckAlt className={isOpen ? "" : "text-xl"} />
                  {isOpen && <span>{translations.sidebar.payments}</span>}
                </div>
              </Link>
            </li>
            <li>
              <Link
                to="/coupons"
                className="group w-full block no-underline text-white hover:bg-gray-700"
              >
                <div
                  className={`flex items-center gap-2 py-2  w-full group-hover:bg-grey-100  transition-colors duration-200 ${
                    isOpen
                      ? `${
                          isRtl
                            ? "pr-12"
                            : "pl-12"
                        }`
                      : "justify-center"
                  }
                   ${isCouponActive ? "bg-[#5A189A]" : "hover:bg-gray-700"}
                  `}
                >
                  <FaGift className={isOpen ? "" : "text-xl"} />
                  {isOpen && <span>{translations.sidebar.coupons}</span>}
                </div>
              </Link>
            </li>
            <li>
              <Link
                to="/charges"
                className="group w-full block no-underline text-white hover:bg-gray-700"
              >
                <div
                  className={`flex items-center gap-2 py-2  w-full group-hover:bg-grey-100  transition-colors duration-200 ${
                    isOpen
                      ? `${
                          isRtl
                            ? "pr-12"
                            : "pl-12"
                        }`
                      : "justify-center"
                  }
                   ${isChargeActive ? "bg-[#5A189A]" : "hover:bg-gray-700"}
                  `}
                >
                  <FaMoneyBillWave className={isOpen ? "" : "text-xl"} />
                  {isOpen && <span>{translations.sidebar.charges}</span>}
                </div>
              </Link>
            </li>
          </ul>
        </div>

        <div className="mt-4 w-full">
          <button
            onClick={() => setIsSupportOffersOpen(!isSupportOffersOpen)}
            className={`flex items-center gap-2 p-2 text-white w-full transition-all duration-300 
    ${isOpen ? "bg-gray-700 justify-start px-4" : "justify-center"} 
    hover:bg-gray-700`}
          >
            <MdLocalOffer className="text-xl" />
            {isOpen && <span>{translations.sidebar.supportOffers}</span>}
            {isOpen && (
              <IoIosArrowDown
                className={`transition-transform duration-300 ${
                  isSupportOffersOpen ? "rotate-180" : ""
                } rtl:ml-0 rtl:mr-auto ltr:ml-auto`}
              />
            )}
          </button>

          {isSupportOffersOpen && (
            <ul className="space-y-2 w-full mx-0 px-0 list-none">
              <li>
                <Link
                  to="/contactUs"
                  className={`flex items-center gap-2 py-2 text-white w-full hover:bg-gray-700 no-underline ${
                    isOpen
                      ? `${
                          isRtl
                            ? "pr-12"
                            : "pl-12"
                        }`
                      : "justify-center"
                  } ${isContactUsActive ? "bg-[#5A189A]" : ""}`}
                >
                  <MdLiveHelp className="text-lg" />
                  
                  {isOpen && <span>{translations.sidebar.contactInfo}</span>}
                </Link>
              </li>
              <li>
                <Link
                  to="/offers"
                  className={`flex items-center gap-2 py-2 text-white w-full hover:bg-gray-700 no-underline ${
                    isOpen
                      ? `${
                          isRtl
                            ? "pr-12"
                            : "pl-12"
                        }`
                      : "justify-center"
                  } ${isOfferActive ? "bg-[#5A189A]" : ""}`}
                >
                  <MdLocalOffer className="text-lg" />
                  {isOpen && <span>{translations.sidebar.weeklyOffers}</span>}
                </Link>
              </li>
            </ul>
          )}
        </div>

        <div className="mt-4 w-full text-white">
          <button
            onClick={() => setIsCustomerSupportOpen(!isCustomerSupportOpen)}
            className={`flex items-center gap-2 p-2 text-white w-full transition-all duration-300 
    ${isOpen ? "bg-gray-700 justify-start px-4" : "justify-center"} 
    hover:bg-gray-700`}
          >
            <MdSupportAgent className="text-xl" />
            {isOpen && <span>{translations.sidebar.customerSupport}</span>}
            {isOpen && (
              <IoIosArrowDown
                className={`transition-transform duration-300 ${
                  isCustomerSupportOpen ? "rotate-180" : ""
                } rtl:ml-0 rtl:mr-auto ltr:ml-auto`}
              />
            )}
          </button>

          {isCustomerSupportOpen && (
            <ul className="space-y-2 w-full list-none mx-0 px-0">
              <li>
                <Link
                  to="/customer/complaints"
                  className={`flex items-center gap-2 py-2 text-white w-full hover:bg-gray-700 no-underline ${
                    isOpen
                      ? `${
                          isRtl
                            ? "pr-12"
                            : "pl-12"
                        }`
                      : "justify-center"
                  } ${isComplaintActive ? "bg-[#5A189A]" : ""}`}
                >
                  <MdOutlineSupportAgent className="text-lg" />
                  {isOpen && <span>{translations.sidebar.complaints}</span>}
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/customer/reports"
                  className={`flex items-center gap-2 py-2 text-white w-full hover:bg-gray-700 no-underline ${
                    isOpen
                      ? `${
                          isRtl
                            ? "justify-end pr-12 pl-4"
                            : "justify-start pl-12 pr-4"
                        }`
                      : "justify-center"
                  } ${isReportActive ? "bg-[#5A189A]" : ""}`}
                >
                  <MdOutlineReportProblem className="text-lg" />
                  {isOpen && <span>{translations.sidebar.reports}</span>}
                </Link>
              </li>
              <li>
                <Link
                  to="/customer/queries"
                  className={`flex items-center gap-2 py-2 text-white w-full hover:bg-gray-700 no-underline ${
                    isOpen
                      ? `${
                          isRtl
                            ? "justify-end pr-12 pl-4"
                            : "justify-start pl-12 pr-4"
                        }`
                      : "justify-center"
                  } ${isQueryActive ? "bg-[#5A189A]" : ""}`}
                >
                  <MdOutlineQuiz className="text-lg" />
                  {isOpen && <span>{translations.sidebar.queries}</span>}
                </Link>
              </li> */}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
